/**
 * Returns `url` when it is a plain `http(s)` link, and `undefined` otherwise.
 *
 * Most URLs a portal page renders as an `href` or hands to `window.open` come
 * from data the portal does not own: catalog annotations are written by
 * whoever controls the `catalog-info.yaml`, and upstream APIs string-concat
 * links from values they were given. React does not sanitise `href`, and
 * `window.open('javascript:…')` runs in the opener's origin in Chromium, so an
 * unvetted value there is stored XSS. Anything that is not an absolute `http`
 * or `https` URL is dropped rather than rendered inert, so callers can use the
 * result to decide whether to offer the link at all.
 */
export const safeHttpUrl = (url: unknown): string | undefined => {
  if (typeof url !== 'string' || !url) {
    return undefined;
  }
  try {
    const { protocol } = new URL(url);
    return protocol === 'http:' || protocol === 'https:' ? url : undefined;
  } catch {
    return undefined;
  }
};
